module.exports = require('./lib/_stream_duplex.js');



//////////////////
// WEBPACK FOOTER
// ./~/readable-stream/duplex-browser.js
// module id = ./node_modules/readable-stream/duplex-browser.js
// module chunks = 0